import { apiConf, sendRequest, ppAxios } from "../config";

/**
 * 获取网站网站
 */
export const getWebsiteUrl = param => {
  return sendRequest(apiConf.chargeback.getWebsiteUrl, param);
};
/**
 * 商户拒付列表查询
 */
export const getChargeBackList = param => {
  return sendRequest(apiConf.chargeback.getChargeBackList, param);
};

// 拒付下载
export const download = (param, option) => {
  return ppAxios(apiConf.chargeback.download, param, option);
};

// 拒付详情查询  chargebackDetail: ["GET", "/merchant/chargeback/detail/"],
export const chargebackDetail = chargebackId => {
  return sendRequest(
    ["GET", `/merchant/chargeBack/${chargebackId}/detail`],
    null
  );
};

// 拒付回复操作
export const replyOperate = param => {
  return sendRequest(apiConf.chargeback.replyOperate, param);
};

// 回复信息查询
export const repayQuery = chargebackId => {
  return sendRequest(
    ["GET", `/merchant/chargeBack/repayQuery/${chargebackId}`],
    null
  );
};

// 枚举查询
export const getChargebackEnum = param => {
  return sendRequest(apiConf.chargeback.getChargebackEnum, { topic: param });
};
